import React from "react";
import style from "./index.module.scss";

export interface AlertProps {
  alertText: string | React.ReactNode;
  className?: string;
  type?: "info" | "danger";
}

export const Alert = ({ alertText, className, type = "info" }: AlertProps) => (
  <div className={[style.alert, type === "danger" ? style.danger : "", className || ""].join(" ")}>{alertText}</div>
);
